import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { MainLayout } from '../layouts/MainLayout';
import { GuestLayout } from '../layouts/GuestLayout';
import { Login } from '../pages/Login';
import { ProtectedRoute } from './ProtectedRoute';
import { AgentsOverview } from '../pages/Agents/Overview';
import { UnprotectedRoute } from './UnprotectedRoute';
import { ClientsOverview } from '../pages/Clients/Overview';
import { ClientDetails } from '../pages/Clients/Details';
import { AgentDetails } from '../pages/Agents/Details';
import { ContactsOverview } from '../pages/Contacts/Overview';
import { ContactDetails } from '../pages/Contacts/Details';
import { ActivityLogsOverview } from '../pages/ActivitiesLog/Overview';
import { ActivityLogDetails } from '../pages/ActivitiesLog/Details';
import { ROUTES } from './Routes';
import { PlannedActivitiesOverview } from '../pages/Activities/Overview';
import { PlannedActivityDetails } from '../pages/Activities/Details';
import { RelationshipManagement } from '../pages/Clients/RelationshipManagement';
import { OpportunitiesDashboard } from '../pages/Opportunities/OpportunitiesDashboard';
import { OpportunitiesOverview } from '../pages/Opportunities/Overview';
import { OpportunityDetails } from '../pages/Opportunities/Details';

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route index element={<Navigate to="activities" replace />} />

          <Route path={ROUTES.clients.overview}>
            <Route index element={<ClientsOverview />} />
            <Route
              path="relationship-management"
              element={<RelationshipManagement />}
            />
            <Route path=":id" element={<ClientDetails />} />
          </Route>

          <Route path={ROUTES.contacts.overview}>
            <Route index element={<ContactsOverview />} />
            <Route path=":id" element={<ContactDetails />} />
          </Route>

          <Route path={ROUTES.opportunities.index}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<OpportunitiesDashboard />} />
            <Route path="overview" element={<OpportunitiesOverview />} />
            <Route path="overview/:id" element={<OpportunityDetails />} />
          </Route>

          <Route path={ROUTES.agents.overview}>
            <Route index element={<AgentsOverview />} />
            <Route path=":id" element={<AgentDetails />} />
          </Route>

          <Route path={ROUTES.activityLog.overview}>
            <Route index element={<ActivityLogsOverview />} />
            <Route path=":id" element={<ActivityLogDetails />} />
          </Route>

          <Route path={ROUTES.activities.overview}>
            <Route index element={<PlannedActivitiesOverview />} />
            <Route path=":id" element={<PlannedActivityDetails />} />
          </Route>
        </Route>
      </Route>

      <Route element={<UnprotectedRoute />}>
        <Route element={<GuestLayout />}>
          <Route index element={<Navigate to={ROUTES.login} replace />} />
          <Route path={ROUTES.login} element={<Login />} />
        </Route>
      </Route>
    </Routes>
  );
};
